import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../stores/hook';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { setSwiperAutoPlay, setTncShow } from '../GetStarted/GetStartedSlice';

interface HomeTncModalProps {
}

const HomeTncModal: React.FC<HomeTncModalProps> = () => {
    const [isShow, setIsShow] = useState<boolean>(false);
    const [text, setText] = useState<any>('');
    const tncShow = useAppSelector((state) => state.getStarted.tncShow);
    const tncText = useAppSelector((state) => state.getStarted.tncText);
    const dispatch = useAppDispatch();
    const listenerRef = useRef(null);

    useEffect(() => {
        if (tncShow) {
            setIsShow(true);
            document.querySelector('body').style.overflow = 'hidden';
        }
    }, [tncShow]);

    useEffect(() => {
        if (tncText != '') {
            setText(tncText);
        }
    }, [tncText]);

    const handleClick = () => {
        setIsShow(false);
        dispatch(setTncShow(false));
        dispatch(setSwiperAutoPlay(true));
        document.querySelector('body').style.overflow = '';
    }

    useEffect(() => {
    const handleLiener = (event: any) => {
      const targetDiv = document.getElementsByClassName('alert-wrapper')[0];
      if (targetDiv && !targetDiv.contains(event.target)) {
        handleClick();
      }
    };

    listenerRef.current = handleLiener;

    if (isShow) {
      document.addEventListener('click', handleLiener);
    } else {
      document.removeEventListener('click', handleLiener);
    }

    return () => {
      document.removeEventListener('click', listenerRef.current);
    };
  }, [isShow]);

    return (
            <>  

        <div className={isShow ? "modal-wrapper show" : "modal-wrapper"} style={{padding:"6px",overflow:"hidden"}}>
            <div className="modal-dialog">
              <div className="modal-content-wrapper" style={{maxWidth:"500px"}}>
                <div className="alert-wrapper" style={{background: '#fff',padding: '44px',verticalAlign: 'middle'}}>
                        <div className="tc_popup barlow-font" id="tc-1">
				            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
                            <div className='mt-3 text-center'>
                                <a data-fancybox-close className='mx-3 default-btn thinner barlow-font' onClick={handleClick}>OK</a>
                            </div>
                        </div>
                </div>
              </div>
            </div>
        </div>
    </>
    );
}
export default HomeTncModal;